<template>
    <van-popup v-model="followPopupData.isShow" overlay-class="popupClass">
        <div class="box">
            <div class="closeBtnBox">
                <i class="iconfont icon-guanbi" @click="$emit('close')"></i>
            </div>
            <div class="titleBox">
                <div class="title">搜货精选公众号</div>
                <div class="tip">请关注平台微信公众号，即可正常提现</div>
            </div>
            <div class="item" v-for="(item, index) in dataList" :key="index">
                <div class="iconBox">
                    <i class="iconfont" :class="item.icon"></i>
                </div>
                <div class="text" v-text="item.text"></div>
                <div class="btn" v-show="item.isShowCopyBtn" @click="copy('搜货精选')">复制</div>
            </div>
            <input id="copy_content" type="text" value=""  style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;">
        </div>
    </van-popup>
</template>

<script>
import { Popup } from 'vant'
import { MessageBox } from 'mint-ui'
export default {
  name: 'FollowPopup',
  props: {
    followPopupData: {
      type: Object,
      default () {
        return {
          isShow: false
        }
      }
    }
  },
  components: {
    'van-popup': Popup
  },
  data () {
    return {
      show: false,
      dataList: [
        {
          icon: 'icon-fuzhi',
          text: '点击复制“搜货精选”',
          isShowCopyBtn: true
        },
        {
          icon: 'icon-weixin2',
          text: '打开微信进行搜索',
          isShowCopyBtn: false
        },
        {
          icon: 'icon-gongzhonghao',
          text: '关注【搜货精选】官方公众号',
          isShowCopyBtn: false
        },
        {
          icon: 'icon-zhengque',
          text: '回到App进行提现。如失败，请等待五分钟后再试',
          isShowCopyBtn: false
        }
      ]
    }
  },
  methods: {
    copy (textValue) {
      if (document.execCommand) {
        // 获取要赋值的input的元素
        var inputElement = document.getElementById('copy_content')
        // 给input框赋值
        inputElement.value = textValue
        // 选中input框的内容
        inputElement.select()
        // 执行浏览器复制命令
        if (document.execCommand('copy', true, null)) {
          this.$toast('复制成功')
        } else {
          MessageBox({
            title: '提示',
            message: '当前浏览器不支持复制功能，请长按选中文字，进行复制',
            confirmButtonText: '知道了',
            confirmButtonClass: 'c000'
          })
        }
        document.activeElement.blur()
      } else {
        MessageBox({
          title: '提示',
          message: '当前浏览器不支持复制功能，请长按选中文字，进行复制',
          confirmButtonText: '知道了',
          confirmButtonClass: 'c000'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
    position: relative;
    width: 300px;
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .closeBtnBox {
        position: absolute;
        right: 0;
        top: -100px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 34px;
        height: 34px;
        z-index: 10000;
        .icon-guanbi {
            position: absolute;
            font-size: 34px;
            color: #fff;
            font-weight: 700;
        }
    }
    .closeBtnBox::after {
        position: absolute;
        content: '';
        bottom: -66px;
        left: 50%;
        margin-left: -.5px;
        width: 1px;
        height: 70px;
        background-color: #fff;
        z-index: -1;
    }
    .titleBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        border-bottom:  1px dashed #f3f3f3;
        .title {
            font-size: 20px;
            margin-bottom: 10px;
            color: #111010;
        }
        .tip {
            color: #929395;
            margin-bottom: 10px;
        }
    }
    .item {
        display: flex;
        align-items: center;
        margin-top: 8%;
        .iconBox {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background-color: #e7f7ff;
            flex-shrink: 0;
            .iconfont {
                color: #3a9eff;
            }
        }
        .text {
            flex: 1;
            margin: 0 10px;
            font-size: 14px;
        }
        .btn {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 40px;
          flex-shrink: 0;
          padding: 2px 8px;
          background-color: #f56c6c;
          color: #fff;
          border-radius: 20px;
        }
    }
}
.van-popup {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 100%;
    background-color: transparent;
    overflow: initial;
}
</style>
